import { createFileRoute } from '@tanstack/react-router'
import { CreateClinicPage } from '_/features/pets/ui/pages/create-clinic-page'

export const Route = createFileRoute('/_authenticated/pets/clinics/create')({
	staticData: { title: 'clinics_create_title' },
	component: CreateClinicPage,
})
